<template>
  <div
    class="container_option_item d-flex flex-wrap justify-start align-center gap bordered rounded bg-grey_1 pa-1 mb-2"
    v-if="!masquer_activite">
    <div class="d-flex flex-column">
      <div class="text-h6 ml-1" style="margin-right: auto">{{ activite.nom }} - {{ activite.get_text_prix() }}</div>
      <div class="ml-1" v-if="activite.get_metadata('infos_supp')" v-html="activite.get_metadata('infos_supp')"></div>
      <div class="text-body ml-1">Places réservables restantes: {{ places_disponibles }}</div>
    </div>



    <div
      v-if="activite.is_selectionnable(mainStore.module.status, mainStore.view_as_admin, mainStore.inscription_as_admin, mainStore.inscription_vip, mainStore.bookingSystem?.groupe)"
      class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
      <div class="text-body-1 pt-2">Quantité</div>
      <v-btn @click="minus_quantity"><v-icon icon="mdi-minus"></v-icon> </v-btn>
      <div class="text-h6">{{ activite.quantite_souhaite }}</div>
      <v-btn @click="plus_quantity"><v-icon icon="mdi-plus"></v-icon> </v-btn>
    </div>


    <div class="justify-self-end" v-else-if="activite.is_complet()">
      <v-chip square color="dark-red">Complet</v-chip>
    </div>
    <div class="justify-self-end" v-else-if="activite.is_closed()">
      <v-chip square color="dark-red">Inscriptions closes</v-chip>
    </div>
    <div class="justify-self-end" v-else>
      <v-chip square color="dark-red">Inscriptions closes</v-chip>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["item", "all_activites", "initial_commande_inscription"],
  data() {
    return {
      desired_quantity: 0,
      activite: {},
      items: [],
    };
  },

  computed: {
    ...mapStores(useMainStore),
    masquer_activite() {
      const masquer_activite = this.activite.get_metadata("masquer_activite");
      if (masquer_activite && masquer_activite == "1") {
        return true;
      }
      return false;
    },
    places_disponibles() {
      const list_inscriptions = this.mainStore.bookingSystem.booking.inscriptions;
      return this.activite.get_places_disponibles(this.all_activites, list_inscriptions, this.mainStore.inscription_vip, false, [], this.initial_commande_inscription, this.mainStore.bookingSystem?.groupe);
    },
  },

  methods: {
    minus_quantity() {
      if (this.activite.quantite_souhaite > 0) {
        this.activite.quantite_souhaite--;
        this.$emit("updateQuantite", this.activite.quantite_souhaite);
      }
    },
    plus_quantity() {
      if (this.places_disponibles > 0) {
        this.activite.quantite_souhaite++;
        this.$emit("updateQuantite", this.activite.quantite_souhaite);
      }
    },

    build_quantity_items() {
      for (let i = 0; i < this.places_disponibles; i++) {
        this.items.push(i);
      }
    },
  },
  created() {
    this.activite = this.item;
    this.build_quantity_items();
  },
};
</script>

<style lang="scss" scoped></style>